import React, { useEffect, useState, useRef } from "react";
import profileIconDefault from "../Assets/images/profile-icon.svg";
import "../Assets/styles/newStyles/PatientDetailsNew.css";
import axios from "../axios";
import AssessmentModal from "./AssessmentModal";
import { useParams } from "react-router-dom";
import { setDate } from "date-fns";
import Topbar from "./Topbar";
// import { Tooltip } from "react-tooltip";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";
import moment from "moment";
import low_risk_img from "../Assets/images/low_risk_meter.svg";
import med_risk_img from "../Assets/images/med_risk_meter.svg";
import high_risk_img from "../Assets/images/high_risk_meter.svg";
import editIcon from "../Assets/images/edit-3.svg";
import editIcon2 from "../Assets/images/edit-2.svg";
import Chart from "react-apexcharts";
import PatientDetail from "./PatientDetail";
import { da } from "date-fns/locale";
import backIcon from "../Assets/images/chevron-left.png";
// import Sliders from '../Assets/images/sliders.png'
import history from "../history";
import Phone from "../Assets/images/phone.png";
import Info from "../Assets/images/info.png";
import paperPlane from "../Assets/images/PaperPlaneTilt - Send.svg";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
// import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import {
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  FormControl,
  InputLabel,
  TextField,
  Snackbar,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import { styled } from "@mui/system";
// import "react-tooltip/dist/react-tooltip.css";
import { NotificationManager } from "react-notifications";
import ClipLoader from "react-spinners/ClipLoader";
import MuiAlert from "@mui/material/Alert";
import ApiService from "../Services/ApiServices";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: "#cc5b02",
    color: "white",
    boxShadow: theme.shadows[1],
    fontSize: 10,
  },
  arrow: {
    color: "#cc5b02",
  },
}));

function PatientDetailsNew(props) {
  const classes = useStyles();
  const targetRef = useRef(null);
  const [name, setName] = useState();
  const [age, setAge] = useState();
  const [gender, setGender] = useState();
  const [plan, setPlan] = useState();
  const [recordId, setRecordId] = useState();
  const [data, setData] = useState();
  const [records, setRecords] = useState([]);
  const [patientDetails, setPatientDetails] = useState({});
  const [currentRecord, setCurrentRecord] = React.useState("");
  const [profileIcon, setProfileIcon] = useState(profileIconDefault);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [frequency, setFrequency] = useState("daily");
  const [frequency1, setFrequency1] = useState("day");
  const [threshold, setThreshold] = useState("low");
  const [recordIndex, setRecordIndex] = useState(0);

  const [prescriptionData, setPrescriptionData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [lhi, setLhi] = useState(null);
  const [tb, setTB] = useState(null);
  const [covid, setCovid] = useState(null);
  const [asthma, setAsthma] = useState(null);
  const [copd, setCopd] = useState(null);
  const [lhiRiskScoreData, setLhiRiskScoreData] = useState([]);
  const [tbRiskScoreData, setTbRiskScoreData] = useState([]);
  const [covidRiskScoreData, setCovidRiskScoreData] = useState([]);
  const [asthmaRiskScoreData, setAsthmaRiskScoreData] = useState([]);
  const [copdRiskScoreData, setCopdRiskScoreData] = useState([]);
  const [riskScoreDates, setRiskScoreDates] = useState([]);
  const [FEV1ScoreData, setFEV1ScoreData] = useState([]);
  const [FVCScoreData, setFVCScoreData] = useState([]);
  const [FEV1FVCScoreData, setFEV1FVCScoreData] = useState([]);
  const [parsedExpression, setParsedExpression] = useState(null);
  const [adherenceChartData, setAdherenceChartData] = useState([]);
  const [xCategories, setXCategories] = useState([]);
  const [yDataSeries, setYDataSeries] = useState([]);
  const [processedData, setProcessedData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [priority, setPriority] = useState("H");
  const [intervalDays, setIntervalDays] = useState("");
  const [hour, setHour] = useState("");
  const [minute, setMinute] = useState("");
  const [isSnackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [remarks, setRemarks] = useState("");
  const [prescriptionId, setPrescriptionId] = useState("");
  const [preLoader, setpreLoader] = useState(false);
  const [assessLoader, setAssessLoader] = useState(false);
  const [showLoader, setShowLoader] = useState(true);

  let date = moment(new Date());
  const [endDate, setEndDate] = useState(
    new Date(date.add(1, "day").valueOf())
  );
  const [startDate, setStartDate] = useState();
  const params = useParams();

  const scrollDown = () => {
    // Use scrollIntoView on the referenced element
    window.scrollBy({ top: window.innerHeight, behavior: "smooth" });
  };

  const calculateAverage = (records, property) => {
    let dailyScores = {};

    // Group records by date and calculate daily averages
    records.forEach((record) => {
      if (
        property !== "fev1_3_value" &&
        property !== "fvc_3_value" &&
        property !== "fev1fvc_2_value"
      ) {
        record[property] = Math.round(record[property]); // Round the property value
      }
      const date = moment(record.timestamp).format("YYYY-MM-DD");
      const score = parseFloat(record[property]); // Parse score as float
      if (isNaN(score)) return;
      if (!dailyScores[date]) {
        dailyScores[date] = { totalScore: score, count: 1 };
      } else {
        dailyScores[date].totalScore += score;
        dailyScores[date].count++;
      }
    });

    // Calculate daily averages
    const averagedData = Object.keys(dailyScores).map((date) => {
      const { totalScore, count } = dailyScores[date];
      const averageScore = totalScore / count;
      const roundedAverageScore = Math.round(averageScore * 10000) / 10000;
      return { date: new Date(date), averageScore: roundedAverageScore }; // Convert date string to Date object
    });

    // Sort the data in descending order based on date
    averagedData.sort((a, b) => a.date - b.date);

    return averagedData;
  };

  useEffect(() => {
    // getPatientRecords(showLoader);
    loadData(showLoader);
  }, []);
  const loadData = async (showLoader) => {
    if (showLoader) {
      setAssessLoader(true);
      setpreLoader(true);
    }

    try {
      let formdata = new FormData();
      formdata.append("patientId", patientId.toString());
      formdata.append("doctorId", doctorId);

      const response = props.responseData;
      if (!response.data.message) {
        setAssessLoader(false);
        setpreLoader(false);
        const successRecords = response.data.records.filter(
          (record) => record.status === "SUCCESS"
        );

        if (response.data.patientDetails.profileURL !== null) {
          setProfileIcon(response.data.patientDetails.profileURL);
        } else {
          setProfileIcon(profileIconDefault);
        }

        const successRecordsCopy = [...successRecords];
        const sortedRecords = successRecordsCopy.sort((a, b) => {
          const dateA = new Date(a.timestamp + " GMT+0530");
          const dateB = new Date(b.timestamp + " GMT+0530");
          return dateB - dateA; // Sort in descending order
        });

        setPatientDetails(response.data.patientDetails);
        const latestRecord = sortedRecords[0];
        // const latestRecord = successRecords[0];
        const records = successRecords;
        setRecords(sortedRecords);

        setData(response.data);

        setLhi(latestRecord.cough_risk_score);
        setTB(latestRecord.tb_RiskScore);
        setCovid(latestRecord.covid_risk_score);
        setAsthma(latestRecord.asthma_risk_score);
        setCopd(latestRecord.COPD_risk_score);

        const startDate = moment(records[0].timestamp);
        const endDate = moment(records[records.length - 1].timestamp);
        const dates = [];

        for (
          let date = startDate;
          date.isSameOrBefore(endDate);
          date.add(1, "day")
        ) {
          dates.push(date.format("DD MMM"));
        }

        setRiskScoreDates(dates);

        const lhiAverageData = calculateAverage(
          successRecords.filter((record) => record.cough_risk_score !== null),
          "cough_risk_score"
        );

        const tbAverageData = calculateAverage(
          successRecords.filter((record) => record.tb_RiskScore !== null),
          "tb_RiskScore"
        );
        const covidAverageData = calculateAverage(
          successRecords.filter((record) => record.covid_risk_score !== null),
          "covid_risk_score"
        );
        const asthmaAverageData = calculateAverage(
          successRecords.filter((record) => record.asthma_risk_score !== null),
          "asthma_risk_score"
        );
        const copdAverageData = calculateAverage(
          successRecords.filter((record) => record.COPD_risk_score !== null),
          "COPD_risk_score"
        );
        const fev1AvgData = calculateAverage(
          successRecords.filter((record) => record.fev1_3_value !== null),
          "fev1_3_value"
        );
        const fvcAvgData = calculateAverage(
          successRecords.filter((record) => record.fvc_3_value !== null),
          "fvc_3_value"
        );
        const fev1FvcAvgData = calculateAverage(
          successRecords.filter((record) => record.fev1fvc_2_value !== null),
          "fev1fvc_2_value"
        );

        setLhiRiskScoreData(lhiAverageData);
        setTbRiskScoreData(tbAverageData);
        setCovidRiskScoreData(covidAverageData);
        setAsthmaRiskScoreData(asthmaAverageData);
        setCopdRiskScoreData(copdAverageData);
        setFEV1ScoreData(fev1AvgData);
        setFVCScoreData(fvcAvgData);
        setFEV1FVCScoreData(fev1FvcAvgData);
        const patient_id = response.data.patientDetails.id;
        prescriptionDetails(patient_id, showLoader);
        getAdherenceData(patient_id);
      }
    } catch (error) {
      setAssessLoader(false);
      setpreLoader(false);
    }
    // setLoader(true)
  };
  // const patientName = props.patientName
  const patientId = decodeURIComponent(params.patientId);
  const doctorId = params.doctorId;
  const patientIdSQL = props.id;
  // const id = props.id
  const getPatientRecords = async (showLoader) => {
    if (showLoader) {
      setAssessLoader(true);
      setpreLoader(true);
    }

    try {
      let formdata = new FormData();
      formdata.append("patientId", patientId.toString());
      formdata.append("doctorId", doctorId);

      const response = await axios.post(`/getPatientRecords`, formdata, {
        headers: {
          accessToken: localStorage.accessToken,
        },
      });

      if (!response.data.message) {
        setAssessLoader(false);
        setpreLoader(false);
        const successRecords = response.data.records.filter(
          (record) => record.status === "SUCCESS"
        );

        if (response.data.patientDetails.profileURL !== null) {
          setProfileIcon(response.data.patientDetails.profileURL);
        } else {
          setProfileIcon(profileIconDefault);
        }

        const successRecordsCopy = [...successRecords];
        const sortedRecords = successRecordsCopy.sort((a, b) => {
          const dateA = new Date(a.timestamp + " GMT+0530");
          const dateB = new Date(b.timestamp + " GMT+0530");
          return dateB - dateA; // Sort in descending order
        });

        setPatientDetails(response.data.patientDetails);
        const latestRecord = sortedRecords[0];
        // const latestRecord = successRecords[0];
        const records = successRecords;
        setRecords(sortedRecords);

        setData(response.data);

        setLhi(latestRecord.cough_risk_score);
        setTB(latestRecord.tb_RiskScore);
        setCovid(latestRecord.covid_risk_score);
        setAsthma(latestRecord.asthma_risk_score);
        setCopd(latestRecord.COPD_risk_score);

        const startDate = moment(records[0].timestamp);
        const endDate = moment(records[records.length - 1].timestamp);
        const dates = [];

        for (
          let date = startDate;
          date.isSameOrBefore(endDate);
          date.add(1, "day")
        ) {
          dates.push(date.format("DD MMM"));
        }

        setRiskScoreDates(dates);

        const lhiAverageData = calculateAverage(
          successRecords.filter((record) => record.cough_risk_score !== null),
          "cough_risk_score"
        );

        const tbAverageData = calculateAverage(
          successRecords.filter((record) => record.tb_RiskScore !== null),
          "tb_RiskScore"
        );
        const covidAverageData = calculateAverage(
          successRecords.filter((record) => record.covid_risk_score !== null),
          "covid_risk_score"
        );
        const asthmaAverageData = calculateAverage(
          successRecords.filter((record) => record.asthma_risk_score !== null),
          "asthma_risk_score"
        );
        const copdAverageData = calculateAverage(
          successRecords.filter((record) => record.COPD_risk_score !== null),
          "COPD_risk_score"
        );
        const fev1AvgData = calculateAverage(
          successRecords.filter((record) => record.fev1_3_value !== null),
          "fev1_3_value"
        );
        const fvcAvgData = calculateAverage(
          successRecords.filter((record) => record.fvc_3_value !== null),
          "fvc_3_value"
        );
        const fev1FvcAvgData = calculateAverage(
          successRecords.filter((record) => record.fev1fvc_2_value !== null),
          "fev1fvc_2_value"
        );

        setLhiRiskScoreData(lhiAverageData);
        setTbRiskScoreData(tbAverageData);
        setCovidRiskScoreData(covidAverageData);
        setAsthmaRiskScoreData(asthmaAverageData);
        setCopdRiskScoreData(copdAverageData);
        setFEV1ScoreData(fev1AvgData);
        setFVCScoreData(fvcAvgData);
        setFEV1FVCScoreData(fev1FvcAvgData);
        const patient_id = response.data.patientDetails.id;
        prescriptionDetails(patient_id, showLoader);
        getAdherenceData(patient_id);
      }
    } catch (error) {
      setAssessLoader(false);
      setpreLoader(false);
    }
    // setLoader(true)
  };

  const prescriptionDetails = async (patient_id, showLoader) => {
    if (localStorage.rpm !== "rpm") {
      return; // Exit the function if the condition is not met
    }

    if (showLoader) {
      setpreLoader(true);
    }

    try {
      const response = await axios.get(`/assessmentschedules`, {
        headers: {
          accessToken: localStorage.accessToken,
        },
        params: {
          patientId: patient_id,
        },
      });

      if (!response.data.message) {
        const latestRecord = response.data[response.data.length - 1];
        setPrescriptionData(response.data);
        setPrescriptionId(latestRecord.id);

        const cronExpression = latestRecord.schedule_cron;
        const cronFields = cronExpression.split(" ");
        const hour24 = parseInt(cronFields[1], 10);
        const minuteString = cronFields[0].padStart(2, "0"); // Ensure minute has two digits
        const hour12 = hour24 % 12 || 12;
        const hourString = hour12.toString().padStart(2, "0"); // Ensure hour has two digits
        const period = hour24 >= 12 ? "PM" : "AM";
        const timeString = `${hourString}:${minuteString} ${period}`;

        let dayOfMonthField;
        if (cronFields.length > 2) {
          dayOfMonthField = cronFields[2];
        } else {
          dayOfMonthField = "*";
        }
        let repeatingDays = 1; // Default to 1 if not specified
        if (dayOfMonthField !== null && dayOfMonthField.startsWith("*/")) {
          repeatingDays = parseInt(dayOfMonthField.slice(2, 4)) || 1;
        }
        let repeatEveryString;
        if (repeatingDays === 1) {
          repeatEveryString = `Repeats every day at ${timeString}`;
        } else {
          repeatEveryString = `Repeats every ${repeatingDays} days at ${timeString}`;
        }

        setParsedExpression(repeatEveryString);
        setpreLoader(false);
        setAssessLoader(false);
      }
    } catch (error) {
      setpreLoader(false);
      setAssessLoader(false);
    }
  };

  const riskFrequency = () => {
    if (prescriptionData[0].priority == "H") {
      return "High LHI";
    } else if (prescriptionData[0].priority == "M") {
      return "Medium LHI";
    } else if (prescriptionData[0].priority == "L") {
      return "Low LHI";
    }
  };

  const riskIcon = () => {
    if (prescriptionData[0].priority == "H") {
      return "red-span";
    } else if (prescriptionData[0].priority == "M") {
      return "yellow-span";
    } else if (prescriptionData[0].priority == "L") {
      return "green-span";
    }
  };

  const getAdherenceData = async (patient_id) => {
    if (localStorage.rpm !== "rpm") {
      return;
    }
    try {
      const response = await axios.get(`/adherence`, {
        headers: {
          accessToken: localStorage.accessToken,
        },
        params: {
          patientId: patient_id,
        },
      });

      if (Array.isArray(response.data.data)) {
        const newData = response.data.data.map((item) => {
          const date = Object.keys(item)[0];
          const formattedDate = moment(date, "YYYY-MM-DD").format("DD MMM");
          const value = item[date] ? 1 : 0;
          return { date: formattedDate, value };
        });

        setProcessedData(newData);
        setAdherenceChartData(newData);

        // Set start, middle, and end dates for x-axis
        const startIndex = 0;
        const middleIndex = Math.floor(newData.length / 2);
        const endIndex = newData.length - 1;
        const startMiddleEndDates = [
          newData[startIndex].date,
          newData[middleIndex].date,
          newData[endIndex].date,
        ];

        // Create categories with empty strings for all dates except start, middle, and end dates
        const xCategories = newData.map(({ date }) =>
          startMiddleEndDates.includes(date) ? date : ""
        );
        setXCategories(xCategories);

        // Set data for y-axis
        setYDataSeries(newData.map((item) => item.value));
      } else {
      }
    } catch (e) {}
  };

  function convertToIST(utcTimestamp) {
    const date = new Date(utcTimestamp);
    const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
    const istTimestamp = date.getTime() + istOffset;
    return new Date(istTimestamp);
  }

  const timeAndRiskdata = records.map((each) => ({
    date: each.timestamp !== null ? convertToIST(each.timestamp) : "",
    riskScore: each.cough_risk_score !== null ? each.cough_risk_score : "",
  }));

  // function compareTimestamps(a, b) {
  //   return new Date(b.date) - new Date(a.date);
  // }

  function compareTimestamps(a, b) {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    // First, compare dates in descending order
    if (dateA > dateB) return -1;
    if (dateA < dateB) return 1;
    // If dates are the same, compare times in descending order
    const timeA = dateA.getTime();
    const timeB = dateB.getTime();
    return timeB - timeA;
  }

  function getRiskStatus(score) {
    let status = "";
    let color = "";

    if (score >= 0 && score <= 3) {
      status = "Low Risk";
      color = "green";
    } else if (score >= 4 && score <= 6) {
      status = "Med Risk";
      color = "orange";
    } else if (score >= 7 && score <= 10) {
      status = "High Risk";
      color = "red";
    }

    return { status, color };
  }

  const formatDate = (dateString) => {
    const dateObj = new Date(dateString);
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = dateObj.toLocaleString("default", { month: "short" });
    const year = dateObj.getFullYear();
    const hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const time = `${formattedHours}:${minutes} ${ampm}`;
    return { day, month, year, time };
  };
  const assessmentsData = timeAndRiskdata.map((each) => {
    const { day, month, year, time } = formatDate(each.date);
    const { status, color } = getRiskStatus(each.riskScore);
    return { day, month, year, time, riskStatus: status, color };
  });

  const modalData = records.map((each) => ({
    date: each.date,
    dryCount: each.dry_sequence_count,
    wetCount: each.wet_sequence_count,
    COPDLikely: each.COPD_likely,
    COPDRiskScore: each.COPD_risk_score,
    asthmaRiskScore: each.asthma_risk_score,
    AsthmaLikely: each.asthma_likely,
    TBLikely: each.tb_likely,
    TBRiskScore: each.tb_RiskScore,
    covidLikely: each.covid_likely,
    covidRiskScore: each.covid_risk_score,
    LHIIndex: each.cough_risk_score !== "" ? each.cough_risk_score : "", // Send empty string if risk score is null
    pattern: each.spirometry,
    percentage_of_wetness: each.percentage_of_wetness , 
    patternSeverity: each.severity,
    underLyingRisk: each.risk,
    symptoms: each.symptoms,
    fev1: each.fev1_3_value,
    fvc: each.fvc_3_value,
    fev1fvc: each.fev1fvc_2_value,
    feedback: each.feedback,
    doctorId: each.userId,
    recordId: each.recordId,
    medicalConditions: each.medical_conditions,
    labelData: each.label,
    profileIcon: profileIcon,
  }));

  const totalData = assessmentsData.map((item, index) => ({
    ...item,
    ...modalData[index],
  }));

  const getCoughAudioRecords = (recordId) => {
    let audioFormData = new FormData();
    audioFormData.append("doctorId", params.doctorId);
    audioFormData.append("recordId", recordId);
    audioFormData.append("patientId", decodeURIComponent(params.patientId));

    axios({
      method: "POST",
      url: "/getCoughAudioRecord",
      data: audioFormData,
      headers: { accessToken: localStorage.accessToken },
    })
      .then((response) => {
        setCurrentRecord(response.data.recordLink);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const assessmentModal = (data, recordId, index) => {
    setData(data);
    getCoughAudioRecords(recordId);
    setShowModal(true);
    setRecordIndex(index);
  };

  const closeModal = () => {
    setCurrentRecord("");
    setShowModal(false);
    getPatientRecords(false);
  };

  const calculateRisk = (score) => {
    if (score >= 0 && score <= 3) {
      return { img: low_risk_img, text: "Low" };
    } else if (score >= 4 && score <= 6) {
      return { img: med_risk_img, text: "Medium" };
    } else if (score >= 7 && score <= 10) {
      return { img: high_risk_img, text: "High" };
    } else {
      return { img: null, text: null };
    }
  };

  const chartOptions = {
    chart: {
      toolbar: {
        show: false,
      },
      fontFamily: "IBM Plex Sans, sans-serif",
    },
    xaxis: {
      categories: props.riskScoreDates,
      // categories: riskScoreDates.length === 1 ? [moment(riskScoreDates[0]).format("DD MMM")] : riskScoreDates.map(date => moment(date).format("D MMM")),
    },
    grid: {
      show: false,
    },
    annotations: {
      yaxis: [
        {
          y: 0, // Value where you want to add the horizontal line
          borderColor: "#000",
          borderWidth: 0.3,
          strokeDashArray: 0,
        },
        {
          y: 5, // Value where you want to add the horizontal line
          borderColor: "#000",
          borderWidth: 0.3,
          strokeDashArray: 0,
        },
        {
          y: 10, // Value where you want to add the horizontal line
          borderColor: "#000",
          borderWidth: 0.3,
          strokeDashArray: 0,
        },
      ],
    },
    yaxis: {
      decimalsInFloat: 0,
      min: 0,
      max: 10,
      labels: {
        formatter: function (value) {
          if (value === 0) {
            return "Low";
          } else if (value === 5) {
            return "Medium";
          } else if (value === 10) {
            return "High";
          } else {
            return "";
          }
        },
      },
    },
    legend: {
      show: false,
    },
  };

  // const goBack = () => {
  //   history.push("/patients");
  // };
  const theme = createTheme({
    overrides: {
      MuiContainer: {
        root: {
          display: "flex",
          flexDirection: "row",
        },
      },
    },
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const history = useHistory();

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleVisitSoon = async () => {
    setIsLoading(true);
    handleCloseMenu();

    try {
      const response = await axios.get(
        `send_visit_hospital_message?patientId=${params.patientId}&userId=${encodeURIComponent(params.doctorId)}`,
        {
          headers: {
            accessToken: localStorage.accessToken,
          },
        }
      );
      
      if (response.data.status === "Success") {
        setIsLoading(false);
        NotificationManager.success("Success", "Notification Sent", 5000);
      } else {
        setIsLoading(false);
        NotificationManager.error(
          "Please try again after sometime",
          "Error",
          5000
        );
      }
      
    } catch (error) {
      // console.error("Error occurred while sending visit message:", error);
      setIsLoading(false);
      NotificationManager.error(
        "Please try again after sometime",
        "Error",
        5000
      );
    }
  };
  const handleTakeAssessment = async () => {
    setIsLoading(true);
    handleCloseMenu();
    try {
      const response = await axios.get(
        `send_take_assessment_message?patientId=${params.patientId}&userId=${encodeURIComponent(params.doctorId)}`,
        {
          headers: {
            accessToken: localStorage.accessToken,
          },
        }
      );
      
      if (response.data.status === "Success") {
        NotificationManager.success("Success", "Notification Sent", 5000);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        NotificationManager.error(
          "Please try again after sometime",
          "Error",
          5000
        );
      }
      
    } catch (error) {
      setIsLoading(false);
      // console.error("Error occurred while sending visit message:", error);
      NotificationManager.error(
        "Please try again after sometime",
        "Error",
        5000
      );
    }
  };

  const checkPaymentEntry = async (each, i) => {
    console.log(each)
    if (localStorage.patientPayment === "true") {
      try {
        const apiService = new ApiService();
        const response = await apiService.getPaymentEntryStatus(each.recordId);
  
        if (response && response.payment_status) {
          const paymentStatus = response.payment_status.toString().toLowerCase();
  
          if (paymentStatus === 'completed') {
            assessmentModal(each, each.recordId, i);
          } else {
            showCustomAlert("Payment is required to unlock detailed report. Kindly collect payment from the patient via Swaasa mobile app  to view this report");
          }
        } else {
          showCustomAlert("Payment is required to unlock detailed report. Kindly collect payment from the patient via Swaasa mobile app  to view this report");
        }
      } catch (error) {
        console.error('Error fetching payment entry status:', error);
      }
    } else {
      assessmentModal(each, each.recordId, i);
    }
  };
  
  

  const openPrescriptionModal = () => {
    setDialogOpen(true);
  };
  const closeDialog = () => {
    setDialogOpen(false);
  };
  const handleFrequencyChange = (event) => setHour(event.target.value);
  const handleMinuteChange = (event) => setMinute(event.target.value);
  const handleStartDateChange = (event) => setStartDate(event.target.value);
  const handleEndDateChange = (event) => setEndDate(event.target.value);

  const handlePriorityChange = (event) => setPriority(event.target.value);
  const handleRemarksChange = (event) => setRemarks(event.target.value);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const generateCronExpression = (hour, minute, intervalDays) => {
    const notificationTimeCron = `${minute} ${hour}`;
    const intervalCron = intervalDays > 1 ? `*/${intervalDays}` : "*";
    return `${notificationTimeCron} ${intervalCron} * * *`;
  };

  const sendPrescription = async () => {
    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);

    setpreLoader(true);
    const cronExpression = generateCronExpression(hour, minute, intervalDays);
    let payload = {};
    if (prescriptionData.length === 0) {
      payload = {
        // schedule_name: patientDetails.firstname,
        patientId: patientIdSQL,
        schedule_cron: cronExpression,
        priority: priority,
        start_date: formattedStartDate,
        end_date: formattedEndDate,
        created_by: doctorId,
      };
    } else {
      payload = {
        id: prescriptionId,
        schedule_name: patientDetails.firstname,
        patientId: patientIdSQL,
        schedule_cron: cronExpression,
        priority: priority,
        start_date: formattedStartDate,
        end_date: formattedEndDate,
        created_by: doctorId,
      };
    }

    try {
      if (prescriptionData.length === 0) {
        const response = await axios.post(`/assessmentschedules`, payload);
      } else {
        const response = await axios.put(`/assessmentschedules`, payload);
      }
      setpreLoader(false);
      NotificationManager.success("Success", "Updated Prescription Data", 5000);
      prescriptionDetails(patientIdSQL);
      closeDialog();
    } catch (error) {
      setpreLoader(false);
      console.error("There was an error making the request!", error);
      NotificationManager.error(
        "Error",
        "Failed to update Prescription Data",
        5000
      );
    }
  };

  const handleFrequency = (e) => {
    setFrequency1(e.target.value);
  };
  const showCustomAlert = (message) => {
    const customAlert = document.getElementById('customAlert');
    const customAlertMessage = document.getElementById('customAlertMessage');
    customAlertMessage.innerText = message;
    customAlert.style.display = 'flex'; // Show the modal in the center
  
    // Add event listener for the OK button
    const okButton = document.getElementById('customAlertOk');
    okButton.onclick = () => {
      customAlert.style.display = 'none'; // Hide the modal when OK is clicked
    };
  };

  return (
    // <div className="dashboard">
    <div className="mainContainer">
      {/* <Topbar /> */}
      <div id="customAlert" class="custom-alert-overlay">
  <div class="custom-alert-box">
    <p id="customAlertMessage">Payment is required to unlock detailed report. Kindly collect payment from the patient via Swaasa mobile app  to view this report</p>
    <button id="customAlertOk">OK</button>
  </div>
</div>

      <div className="backbutton-profile">
        {localStorage.validation !== "true" ||
        localStorage.longitudinal_study === "true" ? (
          ""
        ) : (
          <div
            style={{ display: "flex", flexDirection: "row" }}
            className="patients__value-filter__item"
          >
            <p className="medicalRecords-status">Status: </p>
            <select
              value={props.status}
              onChange={(e) => props.statusCall(e.target.value)}
            >
              <option value="NEW">NEW</option>
              <option value="COMPLETED">COMPLETED</option>
            </select>
          </div>
        )}
        <div className="patientDetails-profile-main-container">
          <div className="patientDetails-profile">
            <div className="patientDetails-profile-card">
              <img
                className="patientDetails-card-img"
                src={profileIcon}
                alt=""
              />
              <div className="patientDetails-cards">
                <div className="patientDetails-card-container">
                  <p className="patientDetails-card-name">
                    {patientDetails.firstname}
                  </p>
                </div>
                <div className="patientDetails-card-container">
                  <p className="patientDetails-id">
                    <span
                      className="patientDetails-span"
                      style={{ fontWeight: "500" }}
                    >
                      Id:{" "}
                    </span>
                    {patientDetails.patientId}
                  </p>
                </div>
                <div className="patientDetails-card-container">
                  <p className="patientDetails-age">
                    {patientDetails.age
                      ? (localStorage.ageValid === "false" ||
                        parseFloat(patientDetails.age) >= 18
                          ? parseFloat(patientDetails.age) % 1 === 0
                            ? String(parseInt(patientDetails.age))
                            : String(parseFloat(patientDetails.age))
                          : parseFloat(patientDetails.age) % 1 === 0
                          ? String(parseInt(patientDetails.age))
                          : String(parseFloat(patientDetails.age))) + " Yrs"
                      : "NA"}
                    | {patientDetails.gender}
                  </p>
                </div>
                {patientDetails.height !== null &&
                  patientDetails.weight !== null &&
                  patientDetails.height !== 0 &&
                  patientDetails.weight !== 0 && (
                    <div className="patientDetails-card-container">
                      <p className="patientDetails-age">
                        Height:
                        <span className="patientDetails-span">
                          {patientDetails.height} cms
                        </span>{" "}
                        | Weight:
                        <span className="patientDetails-span">
                          {patientDetails.weight} Kg
                        </span>
                      </p>
                    </div>
                  )}

                {patientDetails.height !== null &&
                  patientDetails.weight === null &&
                  patientDetails.height !== 0 && (
                    <div className="patientDetails-card-container">
                      <p className="patientDetails-age">
                        Height:{" "}
                        <span className="patientDetails-span">
                          {patientDetails.height} cms
                        </span>
                      </p>
                    </div>
                  )}

                {patientDetails.weight !== null &&
                  patientDetails.height === null &&
                  patientDetails.weight !== 0 && (
                    <div className="patientDetails-card-container">
                      <p className="patientDetails-age">
                        Weight:{" "}
                        <span className="patientDetails-span">
                          {patientDetails.weight} Kg
                        </span>
                      </p>
                    </div>
                  )}
                <div style={{ display: "flex", flexDirection: "row" }}>
                  {localStorage.validation === "true" && (
                    <p className="patientDetails-age">
                      <a
                        href={`/crf/${params.doctorId}/${params.userId}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        CRF
                      </a>
                    </p>
                  )}
                  {localStorage.validation === "true" && (
                    <p className="patientDetails-age">
                      Religion:&nbsp;{" "}
                      <span>
                        {patientDetails?.religion === undefined
                          ? "NA"
                          : patientDetails?.religion}
                      </span>
                    </p>
                  )}
                </div>
                {localStorage.validation === "true" && (
                  <p className="patientDetails-age">
                    Income:&nbsp;{" "}
                    <span>
                      {patientDetails?.income === undefined
                        ? "NA"
                        : patientDetails?.income}
                    </span>
                  </p>
                )}
                <div className="patientDetails-card-container">
                  <div className="patientDetails-number">
                    {patientDetails.mobileNumber && (
                      <>
                        <img
                          src={Phone}
                          alt="phone"
                          style={{ height: "18px", weight: "18px" }}
                        />
                        <p className="span-mobile-number">
                          {patientDetails.mobileNumber}
                        </p>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {localStorage.rpm === "rpm" && <hr className="line" />}
            <div className="patientDetails-prescription-main">
              {localStorage.rpm === "rpm" && (
                <>
                  <div className="p-header">
                    <h1 className="prescription-heading">Prescription</h1>
                    {/* <div className="pd-edit"> */}
                    <div className="pd-edit" onClick={openPrescriptionModal}>
                      <p className="pd-np-3">Change</p>
                      <div className="p-edit">
                        <img className="edit-icon" src={editIcon2} alt="" />
                      </div>
                    </div>
                  </div>
                  <div className="prescription-card">
                    {preLoader || assessLoader ? (
                      <div
                        className="assessment-card"
                        style={{
                          height: "180px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <ClipLoader color="orange" size={25} />
                      </div>
                    ) : prescriptionData.length === 0 ? (
                      <div className="pd-np-no">
                        <img src={editIcon} alt="" />
                        <p className="pd-np">
                          This patient doesn't have a prescription yet <br />
                        </p>
                      </div>
                    ) : (
                      <div>
                        <div className="prescription-details">
                          <p className="prescription-headings">Frequency</p>
                          <p className="schedule-text">{parsedExpression}</p>
                        </div>
                        <hr className="inline" />
                        <div className="prescription-details">
                          <div style={{ display: "flex" }}>
                            <h1 className="prescription-headings">
                              Alert Threshold{" "}
                            </h1>

                            <Tooltip
                              title={
                                "Breach alert will be sent when the assessment LHI equals to Alert Threshold"
                              }
                              classes={{
                                tooltip: classes.tooltip,
                                arrow: classes.arrow,
                              }}
                              arrow
                            >
                              <img
                                src={Info}
                                className="info-icon"
                                alt="info"
                              />
                            </Tooltip>
                          </div>

                          <div className="prescription-details-treshold">
                            <div className={riskIcon()}></div>
                            <p className="treshold-text">{riskFrequency()}</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <Dialog
                    open={isDialogOpen}
                    onClose={closeDialog}
                    sx={{
                      "& .MuiPaper-root": {
                        width: "50%",
                        borderRadius: "16px",
                      },
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "15px 24px 0px 24px",
                      }}
                    >
                      <DialogTitle
                        style={{
                          fontSize: "18px",
                          margin: 0,
                          padding: 0,
                          color: "#354764",
                        }}
                      >
                        Changing Prescription
                      </DialogTitle>
                      <Button
                        onClick={closeDialog}
                        sx={{ color: "#E63900" }}
                        style={{
                          fontSize: "12px",
                          textTransform: "capitalize",
                        }}
                      >
                        Close
                      </Button>
                    </div>
                    <DialogContent>
                      <div
                        className="prescriptionDialog"
                        style={{ padding: "0 24px" }}
                      >
                        <div className="p-d-content">
                          <h1
                            className="p-d-headings"
                            style={{ color: "#B55900", marginBottom: "0px" }}
                          >
                            Schedule
                          </h1>
                          <div className="p-d-inputs">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "16px",
                              }}
                            >
                              <FormControl
                                fullWidth
                                sx={{ width: "150px" }}
                                margin="normal"
                              >
                                <p className="label-prescription">Start Date</p>
                                <TextField
                                  fullWidth
                                  type="date"
                                  variant="outlined"
                                  value={startDate}
                                  onChange={handleStartDateChange}
                                  sx={{
                                    ".MuiOutlinedInput-root": {
                                      borderRadius: "8px",
                                      border: "1px solid #ced4da",
                                      fontSize: "12.5px",
                                      fontWeight: "500",
                                      color: "#131313",
                                    },
                                    ".MuiOutlinedInput-notchedOutline": {
                                      border: "none",
                                    },
                                  }}
                                />
                              </FormControl>
                              <FormControl
                                fullWidth
                                sx={{ width: "150px" }}
                                margin="normal"
                              >
                                <p className="label-prescription">End Date</p>
                                <TextField
                                  fullWidth
                                  type="date"
                                  variant="outlined"
                                  value={endDate}
                                  onChange={handleEndDateChange}
                                  sx={{
                                    ".MuiOutlinedInput-root": {
                                      borderRadius: "8px",
                                      border: "1px solid #ced4da",
                                      fontSize: "12.5px",
                                      fontWeight: "500",
                                      color: "#131313",
                                    },
                                    ".MuiOutlinedInput-notchedOutline": {
                                      border: "none",
                                    },
                                  }}
                                />
                              </FormControl>
                              <FormControl margin="normal">
                                <p
                                  className="label-prescription"
                                  style={{ marginBottom: "2px" }}
                                >
                                  Repeats every
                                </p>
                                {frequency1 === "day" && (
                                  <Select
                                    labelId="interval-days-label"
                                    id="interval-days-select"
                                    value={intervalDays}
                                    onChange={(e) =>
                                      setIntervalDays(e.target.value)
                                    }
                                    style={{ width: "190px" }}
                                    displayEmpty
                                    sx={{
                                      ".MuiSelect-select": {
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "14px 14px",
                                        borderRadius: "8px",
                                        border: "1px solid #ced4da",
                                        backgroundColor: "#fff",
                                        fontSize: "14px",
                                        borderTopRightRadius: "0px",
                                        borderBottomRightRadius: "0px",
                                      },
                                      ".MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                      },
                                    }}
                                  >
                                    <MenuItem value="" disabled>
                                      Select Days
                                    </MenuItem>
                                    {Array.from(
                                      { length: 10 },
                                      (_, i) => i + 1
                                    ).map((value) => (
                                      <MenuItem key={value} value={value}>
                                        {value}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                )}

                                {frequency1 === "hour" && (
                                  <Select
                                    labelId="hour-label"
                                    id="hour-select"
                                    value={hour}
                                    onChange={handleFrequencyChange}
                                    style={{ width: "190px" }}
                                    displayEmpty
                                    sx={{
                                      ".MuiSelect-select": {
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "14px 14px",
                                        borderRadius: "8px",
                                        border: "1px solid #ced4da",
                                        backgroundColor: "#fff",
                                        fontSize: "14px",
                                        borderTopRightRadius: "0px",
                                        borderBottomRightRadius: "0px",
                                      },
                                      ".MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                      },
                                    }}
                                  >
                                    <MenuItem value="" disabled>
                                      Select Hours
                                    </MenuItem>
                                    {Array.from(
                                      { length: 24 },
                                      (_, i) => i
                                    ).map((value) => (
                                      <MenuItem key={value} value={value}>
                                        {value}:00
                                      </MenuItem>
                                    ))}
                                  </Select>
                                )}
                                {frequency1 === "minute" && (
                                  <Select
                                    labelId="minute-label"
                                    id="minute-select"
                                    value={minute}
                                    onChange={handleMinuteChange}
                                    style={{ width: "190px" }}
                                    displayEmpty
                                    sx={{
                                      ".MuiSelect-select": {
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "14px 14px",
                                        borderRadius: "8px",
                                        border: "1px solid #ced4da",
                                        backgroundColor: "#fff",
                                        fontSize: "14px",
                                        borderTopRightRadius: "0px",
                                        borderBottomRightRadius: "0px",
                                      },
                                      ".MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                      },
                                    }}
                                  >
                                    <MenuItem value="" disabled>
                                      Select Minutes
                                    </MenuItem>
                                    {Array.from(
                                      { length: 60 },
                                      (_, i) => i
                                    ).map((value) => (
                                      <MenuItem key={value} value={value}>
                                        {value}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                )}
                              </FormControl>
                              <FormControl margin="normal">
                                <Select
                                  labelId="priority-label"
                                  id="priority-select"
                                  value={frequency1}
                                  onChange={handleFrequency}
                                  style={{ width: "90px" }}
                                  sx={{
                                    ".MuiSelect-select": {
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "15px 14px",
                                      borderRadius: "8px",
                                      border: "1px solid #ced4da",
                                      fontSize: "13px",
                                      backgroundColor: "#F5F6F7",
                                      color: "#131313",
                                      marginTop: "16px",
                                      marginLeft: "-18px",
                                      borderTopLeftRadius: "0px",
                                      borderBottomLeftRadius: "0px",
                                    },
                                    ".MuiOutlinedInput-notchedOutline": {
                                      border: "none",
                                    },
                                    ".MuiSelect-icon": {
                                      marginTop: "8px ", // Adjust this value as needed
                                    },
                                  }}
                                >
                                  <MenuItem value="day">Day</MenuItem>
                                  <MenuItem value="hour">Hours</MenuItem>
                                  <MenuItem value="minute">Minutes</MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                            <FormControl fullWidth margin="normal">
                              <p
                                className="p-d-headings"
                                style={{ color: "#B55900" }}
                              >
                                Threshold Alert
                              </p>
                              <p
                                style={{
                                  color: "#354764",
                                  fontSize: "12px",
                                  marginBottom: "5px",
                                  fontWeight: "500",
                                }}
                              >
                                If the risk level is
                              </p>
                              <Select
                                labelId="priority-label"
                                id="priority-select"
                                value={priority}
                                onChange={handlePriorityChange}
                                style={{ width: "250px" }}
                                sx={{
                                  ".MuiSelect-select": {
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "10px 14px",
                                    borderRadius: "8px",
                                    border: "1px solid #ced4da",
                                    backgroundColor: "#fff",
                                    fontSize: "13px",
                                    color: "#131313",
                                  },
                                  ".MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                }}
                              >
                                <MenuItem value="L">Low</MenuItem>
                                <MenuItem value="M">Medium</MenuItem>
                                <MenuItem value="H">High</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl fullWidth margin="normal">
                              <p
                                className="p-d-headings"
                                style={{ color: "#B55900" }}
                              >
                                Remarks
                              </p>
                              <TextField
                                fullWidth
                                type="text"
                                variant="outlined"
                                value={remarks}
                                onChange={handleRemarksChange}
                                placeholder="Enter remarks"
                                multiline
                                rows={2}
                                sx={{
                                  ".MuiOutlinedInput-root": {
                                    borderRadius: "8px",
                                    border: "1px solid #ced4da",
                                    fontSize: "12.5px",
                                    fontWeight: "500",
                                    color: "#131313",
                                  },
                                  ".MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                }}
                              />
                            </FormControl>
                          </div>
                        </div>
                      </div>
                      {preLoader ? (
                        <div
                          className="sendChangesButton"
                          style={{ marginLeft: "220px", paddingTop: "15px" }}
                        >
                          <ClipLoader color="white" size={25} />
                        </div>
                      ) : (
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <button
                            className="sendChangesButton"
                            onClick={sendPrescription}
                          >
                            Set Prescription to Patient
                          </button>
                        </div>
                      )}
                    </DialogContent>
                    <Snackbar
                      open={isSnackbarOpen}
                      autoHideDuration={6000}
                      onClose={handleCloseSnackbar}
                    >
                      <MuiAlert
                        elevation={6}
                        variant="filled"
                        onClose={handleCloseSnackbar}
                        severity={snackbarSeverity}
                      >
                        {snackbarMessage}
                      </MuiAlert>
                    </Snackbar>
                  </Dialog>
                </>
              )}
              <hr className="line" />
              {/* <div className="patientDetails-prescription-main"> */}
              <div className="assessments-upper-container">
                <h1 className="assessments-heading">Assessments</h1>
                {/* <img src={Sliders} className='sorting-icon' alt='sorting'/> */}
              </div>
              {assessLoader ? (
                <div
                  className="assessment-card"
                  style={{
                    height: "180px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "280px",
                  }}
                >
                  <ClipLoader color="orange" size={25} />
                </div>
              ) : totalData.length === 0 ? (
                <div
                  className="assessments-card"
                  style={{ justifyContent: "center" }}
                >
                  <p className="pd-np">
                    This patient doesn't have an assessment yet
                  </p>
                </div>
              ) : (
                <div className="assessments-card assessment-scroll">
                  {totalData.map((each, i) => (
                    <div
                      key={i}
                      className="assessment-card"
                      onClick={() => checkPaymentEntry(each, i)}  
                    >
                      <div className="date-container">
                        <p className="day">{each.day}</p>
                        <p className="month">{each.month}</p>
                      </div>
                      <div className="time-container">
                        <p style={{ padding: "4px", fontWeight: "400" }}>
                          {each.time}
                        </p>
                      </div>
                      <div className="risk-container">
                        <p
                          style={{
                            border: "1px solid",
                            borderColor: each.color,
                          }}
                          className="risk-circle"
                        ></p>
                        <p style={{ color: each.color }}>{each.riskStatus}</p>
                        {each.labelData != null && (<div className="label-tag"
                        ><p className="label-tag-name">Label</p></div>)}
                      </div>
                    </div>
                  ))}
                  {showModal && (
                    <AssessmentModal
                      data={data}
                      recordIndex={recordIndex}
                      name={patientDetails.firstname}
                      record={currentRecord}
                      onClose={closeModal}
                      showModal={showModal}
                      getPatientRecords={getPatientRecords}
                    />
                  )}
                </div>
              )}
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>

      <div style={{ height: "100vh" }}>
        {localStorage.validation !== "true" ||
        localStorage.longitudinal_study === "true" ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <h1 className="trends-heading">Trends</h1>
            <ThemeProvider theme={theme}>
              {isLoading ? (
                <div
                  className="button-send-msg"
                  style={{
                    textAlign: "center",
                    paddingTop: "2px",
                    width: "127px",
                  }}
                >
                  <ClipLoader color="white" size={20} />
                </div>
              ) : (
                <div className="button-send-msg" onClick={handleOpenMenu}>
                  <p className="send-msg">Send Message</p>
                  <img src={paperPlane} alt="" />
                </div>
              )}

              <Menu
                id="profile-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                getContentAnchorEl={null}
              >
                <MenuItem onClick={handleVisitSoon}>
                  <ListItemText primary="Visit Hospital" />
                </MenuItem>
                <MenuItem onClick={handleTakeAssessment}>
                  <ListItemText primary="Take Assessment" />
                </MenuItem>
              </Menu>
            </ThemeProvider>
            {localStorage.validation !== "true" ||
            localStorage.longitudinal_study === "true" ? (
              ""
            ) : (
              <div
                style={{ display: "flex", flexDirection: "row" }}
                className="patients__value-filter__item"
              >
                <p className="medicalRecords-status">Status: </p>
                <select
                  value={props?.status}
                  onChange={(e) => props.statusCall(e.target.value)}
                >
                  <option value="NEW">NEW</option>
                  <option value="COMPLETED">COMPLETED</option>
                </select>
              </div>
            )}
          </div>
        ) : (
          <></>
        )}
        {localStorage.validation !== "true" ||
        localStorage.longitudinal_study === "true" ? (
          <div className="pd-trends-main">
            <div className="trends-header"></div>
            <div className="scores-and-symptoms">
              <div
                className="pd-scores"
                style={{ borderRight: "1px solid #ededed" }}
              >
                <h1 className="scores-heading">Latest Scores</h1>
                {localStorage.validation === "true" &&
                  localStorage.longitudinal_study !== "true" && (
                    <p className="pd-scores-np">
                      There is No data to show, Please scroll down <br /> to see{" "}
                      <span
                        onClick={scrollDown}
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        {" "}
                        Medical Records{" "}
                      </span>{" "}
                      section.
                    </p>
                  )}
                <div className="scores-cards">
                  {assessLoader ? (
                    <div
                       style={{height:'80px', marginTop:'40px', marginLeft:'170px'}}
                      >
                        <ClipLoader color="orange" size={25} />
                      </div>
                  ) : (
                    <>
                      {(localStorage.validation !== "true" ||
                        localStorage.longitudinal_study === "true") &&
                        localStorage.lhi === "true" && (totalData.length !== 0) && (
                          <div className="trends-wheel-container">
                            <p className="trends-wheel-text">
                              Lung Health Index
                            </p>
                            <img
                              className="trends-wheel-img"
                              src={calculateRisk(lhi).img}
                              alt=""
                            />
                            <p className="trends-wheel-score">
                              {calculateRisk(lhi).text}
                            </p>
                          </div>
                        )}
                      {localStorage.Tb === "tb" && tb !== null && (
                        <div className="trends-wheel-container">
                          <p className="trends-wheel-text">TB Risk</p>
                          <img
                            className="trends-wheel-img"
                            src={calculateRisk(tb).img}
                            alt=""
                          />
                          <p className="trends-wheel-score">
                            {calculateRisk(tb).text}
                          </p>
                        </div>
                      )}
                      {localStorage.plan === "covid" && covid !== null && (
                        <div className="trends-wheel-container">
                          <p className="trends-wheel-text">COVID Risk</p>
                          <img
                            className="trends-wheel-img"
                            src={calculateRisk(covid).img}
                            alt=""
                          />
                          <p className="trends-wheel-score">
                            {calculateRisk(covid).text}
                          </p>
                        </div>
                      )}
                      {localStorage.asthma === "asthma" && asthma !== null && (
                        <div className="trends-wheel-container">
                          <p className="trends-wheel-text">Asthma Risk</p>
                          <img
                            className="trends-wheel-img"
                            src={calculateRisk(asthma).img}
                            alt=""
                          />
                          <p className="trends-wheel-score">
                            {calculateRisk(asthma).text}
                          </p>
                        </div>
                      )}
                      {localStorage.copd === "copd" && copd !== null && (
                        <div className="trends-wheel-container">
                          <p className="trends-wheel-text">COPD Risk</p>
                          <img
                            className="trends-wheel-img"
                            src={calculateRisk(copd).img}
                            alt=""
                          />
                          <p className="trends-wheel-score">
                            {calculateRisk(copd).text}
                          </p>
                        </div>
                      )}
                      {lhi === null &&
                        tb === null &&
                        covid === null &&
                        asthma === null &&
                        copd === null && (
                          <p
                            style={{ margin: "0px 0 0 20px" }}
                            className="pd-np"
                          >
                            No Records Found
                          </p>
                        )}
                    </>
                  )}
                </div>
              </div>
              {localStorage.rpm === "rpm" && (
                <div className="pd-scores">
                  <h1 className="scores-heading">Adherence Chart</h1>
                  {adherenceChartData.length >= 1 ? (
                    <div className="pd-chart">
                      <Chart
                        options={{
                          chart: {
                            toolbar: {
                              show: false,
                            },
                            fontFamily: "IBM Plex Sans, sans-serif",
                            dropShadow: {
                              enabled: true,
                              blur: 3,
                              left: 1,
                              top: 1,
                              opacity: 0.2,
                            },
                          },
                          xaxis: {
                            categories: xCategories,
                          },
                          yaxis: {
                            min: 0,
                            max: 5,
                            tickAmount: 0,
                            title: {
                              text: "Count",
                            },
                            labels: {
                              formatter: function (value) {
                                return value === 5
                                  ? "1"
                                  : value === 0
                                  ? "0"
                                  : "";
                              },
                            },
                          },
                          annotations: {
                            position: "front",
                            yaxis: [
                              {
                                y: 0,
                                borderColor: "#000",
                                borderWidth: 0.3,
                                strokeDashArray: 0,
                              },
                              {
                                y: 5,
                                borderColor: "#000",
                                borderWidth: 0.3,
                                strokeDashArray: 0,
                              },
                            ],
                          },
                          legend: {
                            show: false,
                            position: "bottom",
                            horizontalAlign: "left",
                            fontSize: "15px",
                            markers: {
                              width: "10px",
                              height: "8px",
                            },
                          },
                          tooltip: {
                            x: {
                              show: true,
                              formatter: function (val) {
                                return val;
                              },
                            },
                          },
                        }}
                        series={[
                          {
                            name: "Adherence Data",
                            data: yDataSeries.map((data) =>
                              data === 0 ? 0 : 5
                            ),
                          },
                        ]}
                        type="line"
                        height={"85%"}
                      />
                    </div>
                  ) : (
                    <div className="pd-chart">
                      <p className="pd-np">No Adherence Data</p>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="pd-charts">
              {localStorage.validation !== "true" ||
              localStorage.longitudinal_study === "true" ? (
                <>
                  <div className="chart-cards">
                    <div className="rows">
                      <h1 className="chart-trend-heading">LHI Trend</h1>
                      <p className="everyday-avg">Daily avg</p>
                    </div>
                    <Chart
                      options={chartOptions}
                      series={[
                        {
                          name: "LHI Trend",
                          data: lhiRiskScoreData.length
                            ? lhiRiskScoreData.map((data) => {
                                const value = data.averageScore;
                                if (value >= 0 && value <= 3) {
                                  return 0;
                                } else if (value >= 4 && value <= 6) {
                                  return 5;
                                } else if (value >= 7 && value <= 10) {
                                  return 10;
                                } else {
                                  return value;
                                }
                              })
                            : [],
                        },
                      ]}
                      type="line"
                      height={"85%"}
                    />
                  </div>
                  <div className="chart-cards">
                    <div className="rows">
                      <h1 className="chart-trend-heading">Dry Cough Counts</h1>
                      <p className="everyday-avg">Daily avg</p>
                    </div>
                    <Chart
                      options={{
                        chart: {
                          toolbar: {
                            show: false,
                          },
                          fontFamily: "IBM Plex Sans, sans-serif",
                        },
                        xaxis: {
                          categories: props.dryCoughDates,
                        },
                        yaxis: {
                          labels: {
                            formatter: function (value) {
                              return Math.round(value); // Round the y-axis values
                            },
                          },
                          min: 0, // Update min to start from 0
                          max: 10,
                          tickAmount: 2,
                          decimalsInFloat: 0,
                        },
                        annotations: {
                          position: "front",
                          yaxis: [
                            {
                              y: 11,
                              borderColor: "#775DD0",
                              label: {
                                borderColor: "#775DD0",
                                style: {
                                  color: "#fff",
                                  background: "#775DD0",
                                },
                                // text: "Risk Threshold",
                              },
                            },
                          ],
                        },
                        legend: {
                          show: true,
                          showForSingleSeries: true,
                          showForNullSeries: true,
                          showForZeroSeries: true,
                          position: "bottom",
                          horizontalAlign: "left",
                          fontSize: "13px",
                          markers: {
                            width: "18px",
                            height: "8px",
                          },
                        },
                      }}
                      series={[
                        {
                          name: "Morning",
                          data: props.dryCoughData.morning,
                        },
                        {
                          name: "Afternoon",
                          data: props.dryCoughData.noon,
                        },
                        {
                          name: "Evening",
                          data: props.dryCoughData.evening,
                        },
                        {
                          name: "Night",
                          data: props.dryCoughData.night,
                        },
                      ]}
                      type="line"
                      height={"85%"}
                    />
                  </div>
                  <div className="chart-cards">
                    <div className="rows">
                      <h1 className="chart-trend-heading">Wet Cough Counts</h1>
                      <p className="everyday-avg">Daily avg</p>
                    </div>
                    <Chart
                      options={{
                        chart: {
                          toolbar: {
                            show: false,
                          },
                          fontFamily: "IBM Plex Sans, sans-serif",
                        },
                        xaxis: {
                          categories: props.wetCoughDates,
                        },
                        yaxis: {
                          labels: {
                            formatter: function (value) {
                              return Math.round(value); // Round the y-axis values
                            },
                          },
                          min: 0, // Update min to start from 0
                          max: 10,
                          tickAmount: 2,
                          decimalsInFloat: 0,
                        },
                        annotations: {
                          position: "front",
                          yaxis: [
                            {
                              y: 11,
                              borderColor: "#775DD0",
                              label: {
                                borderColor: "#775DD0",
                                style: {
                                  color: "#fff",
                                  background: "#775DD0",
                                },
                                // text: "Risk Threshold",
                              },
                            },
                          ],
                        },
                        legend: {
                          show: true,
                          showForSingleSeries: true,
                          showForNullSeries: true,
                          showForZeroSeries: true,
                          position: "bottom",
                          horizontalAlign: "left",
                          fontSize: "13px",
                          markers: {
                            width: "18px",
                            height: "8px",
                          },
                        },
                      }}
                      series={[
                        {
                          name: "Morning",
                          data: props.wetCoughData.morning,
                        },
                        {
                          name: "Afternoon",
                          data: props.wetCoughData.noon,
                        },
                        {
                          name: "Evening",
                          data: props.wetCoughData.evening,
                        },
                        {
                          name: "Night",
                          data: props.wetCoughData.night,
                        },
                      ]}
                      type="line"
                      height={"85%"}
                    />
                  </div>
                </>
              ) : (
                <></>
              )}
              {localStorage.Tb === "tb" && tbRiskScoreData.length > 0 && (
                <div className="chart-cards">
                  <div className="rows">
                    <h1 className="chart-trend-heading">TB Trend</h1>
                    <p className="everyday-avg">Daily avg</p>
                  </div>
                  <Chart
                    options={chartOptions}
                    series={[
                      {
                        name: "TB Trend",
                        data: tbRiskScoreData.length
                          ? tbRiskScoreData.map((data) => {
                              const value = data.averageScore;
                              if (value >= 0 && value <= 3) {
                                return 0;
                              } else if (value >= 4 && value <= 6) {
                                return 5;
                              } else if (value >= 7 && value <= 10) {
                                return 10;
                              } else {
                                return value;
                              }
                            })
                          : [],
                      },
                    ]}
                    type="line"
                    height={"85%"}
                  />
                </div>
              )}
              {localStorage.plan === "covid" &&
                covidRiskScoreData.length > 0 && (
                  <div className="chart-cards">
                    <div className="rows">
                      <h1 className="chart-trend-heading">Covid Trend</h1>
                      <p className="everyday-avg">Daily avg</p>
                    </div>
                    <Chart
                      options={chartOptions}
                      series={[
                        {
                          name: "Covid Trend",
                          data: covidRiskScoreData.length
                            ? covidRiskScoreData.map((data) => {
                                const value = data.averageScore;
                                if (value >= 0 && value <= 3) {
                                  return 0;
                                } else if (value >= 4 && value <= 6) {
                                  return 5;
                                } else if (value >= 7 && value <= 10) {
                                  return 10;
                                } else {
                                  return value;
                                }
                              })
                            : [],
                        },
                      ]}
                      type="line"
                      height={"85%"}
                    />
                  </div>
                )}
              {localStorage.asthma === "asthma" &&
                asthmaRiskScoreData.length > 0 && (
                  <div className="chart-cards">
                    <div className="rows">
                      <h1 className="chart-trend-heading">Asthma Trend</h1>
                      <p className="everyday-avg">Daily avg</p>
                    </div>
                    <Chart
                      options={chartOptions}
                      series={[
                        {
                          name: "asthma Trend",
                          data: asthmaRiskScoreData.length
                            ? asthmaRiskScoreData.map((data) => {
                                const value = data.averageScore;
                                if (value >= 0 && value <= 3) {
                                  return 0;
                                } else if (value >= 4 && value <= 6) {
                                  return 5;
                                } else if (value >= 7 && value <= 10) {
                                  return 10;
                                } else {
                                  return value;
                                }
                              })
                            : [],
                        },
                      ]}
                      type="line"
                      height={"85%"}
                    />
                  </div>
                )}
              {localStorage.copd === "copd" && copdRiskScoreData.length > 0 && (
                <div className="chart-cards">
                  <div className="rows">
                    <h1 className="chart-trend-heading">Copd Trend</h1>
                    <p className="everyday-avg">Daily avg</p>
                  </div>
                  <Chart
                    options={chartOptions}
                    series={[
                      {
                        name: "Copd Trend",
                        data: copdRiskScoreData.length
                          ? copdRiskScoreData.map((data) => {
                              const value = data.averageScore;
                              if (value >= 0 && value <= 3) {
                                return 0;
                              } else if (value >= 4 && value <= 6) {
                                return 5;
                              } else if (value >= 7 && value <= 10) {
                                return 10;
                              } else {
                                return value;
                              }
                            })
                          : [],
                      },
                    ]}
                    type="line"
                    height={"85%"}
                  />
                </div>
              )}
              {localStorage.spirometry === "spirometry" &&
                (FEV1ScoreData.some((record) => record !== null) ||
                  FVCScoreData.some((record) => record !== null) ||
                  FEV1FVCScoreData.some((record) => record !== null)) && (
                  <div className="chart-cards">
                    <h1 className="chart-trend-heading">FEV1, FVC, FEV1/FVC</h1>
                    <Chart
                      options={{
                        chart: {
                          toolbar: {
                            show: false,
                          },
                          fontFamily: "IBM Plex Sans, sans-serif",
                        },
                        xaxis: {
                          categories: riskScoreDates,
                        },
                        yaxis: {
                          decimalsInFloat: 0,
                          min: 0,
                          max: 200,
                        },
                        legend: {
                          show: true, // Show legend to distinguish different series
                        },
                      }}
                      series={[
                        {
                          name: "FEV1 Score",
                          data: FEV1ScoreData.map(
                            (record) => record.averageScore
                          ),
                        },
                        {
                          name: "FVC Score",
                          data: FVCScoreData.map(
                            (record) => record.averageScore
                          ),
                        },
                        {
                          name: "FEV1/FVC Score",
                          data: FEV1FVCScoreData.map(
                            (record) => record.averageScore
                          ),
                        },
                      ]}
                      type="line"
                      height={"100%"}
                    />
                  </div>
                )}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default PatientDetailsNew;
